
<script>
import Vue from 'vue';
import ScheduleReprogramyView from './ScheduleReprogramyView.vue'
import ScheduleAddView from './ScheduleAddView.vue';
import EntityService from "@/services/entityService.js";
import View from '@/api/v2/View.mjs';
import UtilMoney from '@/utils/UtilMoney.js';

export default {
    name: 'ScheduleJOBView',
    components: {
        ScheduleReprogramyView,
        ScheduleAddView
    },
    data() {
        return {
            entityService: new EntityService('Project'),
            entityParcela: new EntityService('Parcelas'),
            showDeleteModal: false,
            search: '',
            jobId: null,
            openReprogramySchedule: false,
            openAddAchedule: false,
            items: [],
            page: 1,
            pageCount: 0,
            itemsPerPage: 0,
            UtilMoney: UtilMoney,
            headers: [
                {
                    text: "Job",
                    value: "code",
                },
                {
                    text: "Cliente",
                    value: "cliente",
                },
                {
                    text: "Valor de Venda (Com Impostos)",
                    value: "valor"
                },
                {
                    text: "Data Abertura",
                    value: 'dataAbertura'
                },
                {
                    text: "Tipo de Equipamento",
                    value: "tipo"
                },
                {
                    text: "Qtd. Parcelas",
                    value: "qtd"
                },
                {
                    text: "Status",
                    value: "status"
                },
                {
                    text: "Actions",
                    value: "actions",
                },

            ],
        }
    },

    methods: {

        async getJobs() {

            let data = await Vue.prototype.$http.post('/View/run', {
                params: [
                    { dataType: "string", name: "codigo", value: this.search }
                ],
                viewName: View.JOB_PROGRAMACAO_DE_PARCELAS,
                page: this.page,
                limit: 30
            });

            this.items = data.data.data.data
            this.pageCount = data.data.data.pages
            this.itemsPerPage = data.data.data.limit
        },

        reprogramySchedule(item) {
            this.jobId = item._id
            this.openReprogramySchedule = true
        },


        async deletePacelaJob(item) {

            if(item.parcelas.length == 0){
                this.$notfy.error("Job não possui parcelas.");
                return
            }

            if (await this.$isConfirmGroupDelete("Tem certeza que deseja deletar a parcela do job ? ", item.code))
            try {
                const results = await Promise.allSettled(
                    item.parcelas.map(async (parcela) => await this.entityParcela.delete(parcela._id))
                )

                results.forEach(result => {
                    if (result.status === 'rejected') {
                        this.$notfy.error('Erro ao deletar parcela:', result.reason)
                        return
                    }
                })

                this.$notfy.success("Parcelas deletadas successfully");

            } catch (error) {
                this.$notfy.error("Falha ao deletar JOB.");
            }

            this.getJobs()
        },

        calcParcelas(parcelas) {
            console.log(parcelas)
            if (!parcelas || parcelas.length === 0) return 0;
            return parcelas.reduce((total, parcela) => total + (parcela.vrlParcela || 0), 0)?.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            });
        },

        pagination(page) {
            this.page = page
            this.getJobs()
        },

        saveJob() {
            this.openAddAchedule = false
            this.getJobs()
        },

    },

    mounted() {
        this.getJobs()
    },

}
</script>


<template>

        <div>

            <h2>Programação de JOB</h2>

            <div class="d-flex w-100 gap-10 search-form">

                <form class="w-100 flex-grow-1" @submit.prevent="getJobs">

                    <v-text-field
                        class="pt-5 pb-5"
                        chips
                        v-model="search"
                        clearable
                        hide-details
                        hide-selected
                        prepend-icon="mdi-magnify"
                        label="Código do Job"
                        solo
                    />

                </form>

                <v-btn color="primary" @click="openAddAchedule = true">	
                    Adicionar
                </v-btn>

            </div>

            <v-data-table
                :headers="headers"
                :items="items"
                class="elevation-1 mt-10"
                disable-sort
                hide-default-footer
                :page.sync="page"
                :items-per-page="itemsPerPage"
                @page-count="pageCount = $event"
            >

                <template #item.valor="{ item }">

                    <span>
                        {{ UtilMoney.toR$BRL(item?.valorComIPIComICMS)}}
                    </span>

                </template>

                <template #item.tipo="{ item }">

                    <span>
                        {{ item.tipoEquipamento[0]?.description || item.tipo }}
                    </span>

                </template>

                <template #item.cliente="{ item }">

                    <span>
                        {{ item.cliente[0]?.razaoSocial }}
                    </span>

                </template>

                <template #item.qtd="{ item }">

                    <span>
                        {{ item.parcelas.length }}
                    </span>

                </template>

                <template #item.dataAbertura="{ item }">
                    
                    <span>
                        {{ new Date(item.dataAbertura).toLocaleDateString() }}
                    </span>

                </template>

                <template #item.status="{ item }">
                    
                    <span>
                        {{ item.status?.split('_').join(' ') }}
                    </span>

                </template>

                <template #item.actions="{ item }">
                    
                    <v-menu
                        bottom
                        left
                
                    >
                        <template v-slot:activator="{ on, attrs }">

                            <v-btn
                                dark
                                icon
                                v-bind="attrs"
                                v-on="on"
                                color="black"
                            >
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>

                        </template>
                        
                        <v-list>

                            <v-list-item style="cursor: pointer" @click="reprogramySchedule(item)">

                                <v-list-item-title>
                                    <span>Visualizar / Editar</span>
                                </v-list-item-title>

                            </v-list-item>

                            <v-list-item style="cursor: pointer" @click="deletePacelaJob(item)">

                                <v-list-item-title>
                                    <span>Excluir</span>
                                </v-list-item-title>

                            </v-list-item>

                        </v-list>

                    </v-menu>

                </template>

            </v-data-table>
            
            <div class="text-center pt-2">

                <v-pagination
                    v-model="page"
                    :length="pageCount"
                    @input="pagination"
                ></v-pagination>

            </div>

            <ScheduleReprogramyView 
                :open="openReprogramySchedule"
                :jobId="jobId"
                @save="openReprogramySchedule = false"
                @cancel="openReprogramySchedule = false"
            />

            <ScheduleAddView 
                :open="openAddAchedule"
                @save="saveJob"
                @cancel="openAddAchedule = false"
            />

        </div>

</template>

<style scoped>
    .container {
        width: '100%'
    }

    .search-form {
        gap: 10px;
        align-items: center;
    }
</style>